/**
 * 向前兼容，内置四种语言包
 */

/* eslint-disable */
import zh_CN from "./locale/zh_CN";
import en_US from "./locale/en_US";
import ja_JP from "./locale/ja_JP";
import ko_KR from "./locale/ko_KR";

type DefaultLocale = Partial<typeof zh_CN>;
export interface Locale extends DefaultLocale {
  /**
   * 当前语言标识
   */
  locale: string;
}

export const translationMap = {
  zh_CN: zh_CN as Locale,
  zh: zh_CN as Locale,
  en_US: { ...zh_CN, ...en_US } as Locale,
  en: { ...zh_CN, ...en_US } as Locale,
  ja: { ...zh_CN, ...en_US, ...ja_JP } as Locale,
  jp: { ...zh_CN, ...en_US, ...ja_JP } as Locale,
  ko: { ...zh_CN, ...en_US, ...ko_KR } as Locale,
};
/* eslint-enable */
